import { CustomerListComponent } from './customer-list/customer-list.component';
export var customerRoutes = [
    {
        path: 'customer',
        data: {
            'expectedRoles': ['Accountant', 'Operation', 'IT']
        },
        children: [
            {
                path: 'list',
                component: CustomerListComponent
            }
        ]
    }
];
var CustomerRoutingModule = (function () {
    function CustomerRoutingModule() {
    }
    return CustomerRoutingModule;
}());
export { CustomerRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-routing.module.ts.pre-build-optimizer.js